module.exports = __webpack_public_path__ + "static/media/IMG_8110.941dd0f6.JPG";